<template>
    <div class="l-get-coin-container" v-if="isShow">
        <div class="l-coin-main">
            <div class="l-coin-content">
                <div class="l-coin-img">
                    <p style="margin-bottom:13px">{{textName}}</p>
                    <p>给你点赞！快收下奖励吧！</p>
                    <!-- <img src="./images/coinImgText.png" alt="" /> -->
                </div>
                <div class="l-coin-text">
                    <div class="l-coin-text-token">
                        <img :src="tokenImg" alt="" />
                        <span>{{tokenName}}</span>
                    </div>
                    <div class="l-coin-text-number">
                        <img src="./images/newCoinImg.png" alt="" />
                        <span>+{{coinNumber}}</span>
                    </div>
                </div>
            </div>
            <div class="l-coin-button">
                <button @click="medalCoin" class="l-dialog-btn-confirm"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "l-achievement-getTokenPopup",
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        coinNumber:{
            type:Number,
            default:0
        },
        tokenName:{
            type:String
        },
        tokenImg:{
            type:String
        },
        textName:{
            type:String
        },
        type:{
            type:Number
        }
    },
    data() {
        return {};
    },
    methods: {
        medalCoin(){
            this.$emit("medalCoin")
        }
    },
};
</script>
<style scoped lang="stylus">
@import './index.styl';
</style>